import { Routes, Route } from 'react-router-dom';
import '@/App.css';
import Navbar          from '@/components/Navbar';
import Footer          from '@/components/Footer';
import FloatingCTA     from '@/components/FloatingCTA';
import PageTransition  from '@/components/PageTransition';
import HomePage        from '@/pages/HomePage';
import ProductsPage    from '@/pages/ProductsPage';
import AboutPage       from '@/pages/AboutPage';
import KnowledgePage   from '@/pages/KnowledgePage';
import NotFoundPage    from '@/pages/NotFoundPage';

function App() {
  return (
    <div className="min-h-screen bg-white font-body">
      <Navbar />
      <PageTransition>
        <Routes>
          <Route path="/"            element={<HomePage />} />
          <Route path="/products"    element={<ProductsPage />} />
          <Route path="/products/:id" element={<ProductsPage />} />
          <Route path="/about"       element={<AboutPage />} />
          <Route path="/knowledge"   element={<KnowledgePage />} />
          <Route path="*"            element={<NotFoundPage />} />
        </Routes>
      </PageTransition>
      <Footer />
      <FloatingCTA />
    </div>
  );
}

export default App;
